export const findKeyIndex = (arr, key) => {
  for (let i = arr.length - 1; i >= 0; i-=1) {
    if (arr[i].includes(key)) {
      return i;
    }
  }
  return 0;
}